'use client';

import { Box } from '@mui/material';

import { GameListHeader, SportsGameCard } from '@/components';
import { EventResponse } from '@/types';

interface GameListByDateProps {
  date: string;
  games: EventResponse[];
  sportSlug: string;
  onTeamClick: (event: EventResponse, teamIndex: 1 | 2, isPreviousMarket?: boolean) => void;
  onPropTradeClick?: (marketId: string, outcomeId: string, isBuy: boolean) => void;
  columnVisibility: { hasMoneyline: boolean; hasSpread: boolean; hasTotal: boolean };
  activeOutcomeId?: string;
  isPreviousMarket?: boolean;
}

export const GameListByDate = ({
  date,
  games = [],
  sportSlug,
  onTeamClick,
  onPropTradeClick,
  columnVisibility,
  activeOutcomeId,
  isPreviousMarket,
}: GameListByDateProps) => {
  const renderGameItem = (game: EventResponse, idx: number) => {
    if (!game) return null;
    return (
      <SportsGameCard
        key={game?.id || idx}
        event={game}
        onTeamClick={onTeamClick}
        onPropTradeClick={onPropTradeClick}
        columnVisibility={columnVisibility}
        sportSlug={sportSlug}
        activeOutcomeId={activeOutcomeId}
        isPreviousMarket={isPreviousMarket}
      />
    );
  };

  const renderedGameItems = games?.map(renderGameItem);

  return (
    <Box key={date} sx={{ mb: 4 }}>
      <GameListHeader date={date} columnVisibility={columnVisibility} />
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>{renderedGameItems}</Box>
    </Box>
  );
};
